import React, { useEffect, createElement } from 'react';
import { LandingPage } from './pages/LandingPage';
// Declare fbq type for TypeScript
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
export function App() {
  useEffect(() => {
    // Check if pixel is already loaded
    if (window.fbq) {
      console.log('Meta Pixel already loaded');
      return;
    }
    // Load Facebook Pixel script
    ;
    (function (f: any, b: Document, e: string, v: string) {
      const n: any = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      const t = b.createElement(e) as HTMLScriptElement;
      t.async = true;
      t.src = v;
      const s = b.getElementsByTagName(e)[0];
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s);
      } else {
        b.head.appendChild(t);
      }
      // Wait for script to load before initializing
      t.onload = () => {
        console.log('Meta Pixel script loaded successfully');
        // Initialize pixel
        window.fbq('init', '1839041636796157');
        console.log('Meta Pixel initialized with ID: 1839041636796157');
        // Track PageView
        window.fbq('track', 'PageView');
        console.log('Meta Pixel: PageView event tracked');
      };
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
  }, []);
  return <LandingPage data-id="element-0" />;
}